import gql from 'graphql-tag';

import dokkioTagFragment from '../fragments/dokkioTagFragment';

export const mutationCreateDokkioTag = gql`
  mutation createDokkioTag (
    $dokkioLabelID: DokkioID
    $name: String!
    $description: String
    $logoID: DokkioID
    $autoApplyConfidenceThreshold: Float
    $appliesToTypes: [AppliesToType!]
    $blacklistNames: [String!]
    $synonyms: [String!]
    $rowCreateMethod: RowCreateMethod!
  ) {
    createDokkioTag (
      dokkioLabelID: $dokkioLabelID
      name: $name
      description: $description
      logoID: $logoID
      autoApplyConfidenceThreshold: $autoApplyConfidenceThreshold
      appliesToTypes: $appliesToTypes
      blacklistNames: $blacklistNames
      synonyms: $synonyms
      rowCreateMethod: $rowCreateMethod
    ) {
      ...dokkioTagFragment
    }
  }
  ${dokkioTagFragment}
`;
export default mutationCreateDokkioTag;
